// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"8f298e46","453":"227eed4e","796":"99ee114e"}[chunkId] + ".chunk.js";
};